/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Image } from "react-bootstrap";
import EditIcon from "../../assets/img/edit.png";
import DeleteIcon from "../../assets/img/delete.png";
import Form from 'react-bootstrap/Form';
import { Scrollbars } from 'react-custom-scrollbars-2';
import Badge from 'react-bootstrap/Badge';
import FiltersForm from "../Common/FiltersForm";
import GetCategory from "../../Api/GetCategory";
import { useSelector, useDispatch } from "react-redux";
import { getCategoryList } from "../../redux/actions/categoryActions";
import CommonModal from "../Common/CommonModal";
import moment from "moment";
import CommonLogout from "../Common/CommonLogout";
import CommonPagination from "../Common/CommonPagination";

const CategoryManagement = () => {
    const dispatch = useDispatch();
    const { accessToken } = useSelector((state) => state.personalReducers);
    const { categoryList } = useSelector((state) => state.categoryReducers);
    const [ userSearch, setUserSearch ] = useState("");
    const [ userType, setUserType ] = useState("all");
    const [ userLimit, setUserLimit ] = useState(10);
    const [ currentPage, setCurrentPage ] = useState(1);
    const [ showModal, setShowModal ] = useState({
        open: false,
        title: "",
        modalType: "",
        Data: {}
    });
    const [ paginationLength, setPaginationLength ] = useState({});

    // page change
    const currentFunction = (page) => {
        setCurrentPage(page);
    };
    
    // clear search box
    const ClearSearchFiled = () => {
        setUserSearch("");
    };

    // select user type
    const SelectUserTypeFnct = (e) => {
        setUserType(e.target.value);
        setCurrentPage(1);
    };

    useEffect(() => {
        fetchData();
    }, [ userSearch, userType, userLimit, currentPage ]);

    // Get data from api
    const fetchData = async () => {
        const categoryList = await GetCategory(accessToken, userSearch, userType, userLimit, currentPage);
        if(categoryList?.status === 200) {
            dispatch(getCategoryList(categoryList.data));
            setPaginationLength(categoryList.pagination);
        } else if(categoryList?.detail === "Token expired.") {
            CommonLogout();
            dispatch(getCategoryList([]));
        } else {
            dispatch(getCategoryList([]));
        };
    };

    // category activate & deactivate function
    const CategoryActivStatus = (user) => {
        setShowModal({
            ...showModal,
            open: !showModal?.open,
            title: "Are you sure?",
            description: `Do you really want to ${user?.is_active ? 'deactivate' : 'active'}`,
            modalType: "not form",
            button: "Yes",
            category: "Category active",
            Data: user
        });
    };

    // category edit function
    const EditCategory = (category) => {
        setShowModal({
            ...showModal,
            open: !showModal?.open,
            title: "Edit Category",
            description: "",
            modalType: "form",
            button: "Edit",
            category: "Edit category",
            Data: category
        });
    };

    // add category function
    const AddCategory = () => {
        setShowModal({
            ...showModal,
            open: !showModal?.open,
            title: "Add Category",
            description: "",
            modalType: "form",
            button: "Add",
            category: "Add category",
        });
    };

    // delete category function
    const DeleteCategory = (category) => {
        setShowModal({
            ...showModal,
            open: !showModal?.open,
            title: "Are you sure?",
            description: "Do you really want to delete",
            modalType: "not form",
            button: "Delete category",
            category: "Delete category",
            Data: category
        });
    };

    return(<>
        <FiltersForm 
            filterType={"Category (Name)"}
            userSearch={userSearch}
            setUserSearch={setUserSearch}
            userType={userType} 
            setUserType={setUserType}
            userLimit={userLimit} 
            setUserLimit={setUserLimit}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            ClearSearchFiled={ClearSearchFiled}
            SelectUserTypeFnct={SelectUserTypeFnct}
            AddCategory={AddCategory}
        />
        <div className="tableContent">
            <Scrollbars 
                style={{ height: paginationLength?.total_records > 10 ? "calc(100% - 87px)" : "calc(100% - 50px)" }} 
                className="ScrollbarsWrapper"
                renderView={props => <div {...props} className="view"/>}
            >
                <div className="table-responsive">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Created At</th>
                                <th>Active</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {categoryList && categoryList?.map((user, index) => {
                                return(<React.Fragment key={index}>
                                <tr>
                                    <td>{user?.name}</td>
                                    <td>{moment(user.created_at).format('LL')}</td>
                                    <td>
                                        <Form className="switchbtn">
                                            <Form.Check 
                                                type="switch"
                                                id="custom-switch"
                                                checked={user?.is_active}
                                                onChange={e => {}}
                                                onClick={() => CategoryActivStatus(user)}
                                            />
                                            <Badge bg={user?.is_active ? "primary" : "danger"}>{user?.is_active ? "Yes" : "No"}</Badge>
                                        </Form>
                                    </td>
                                    <td>
                                        <button className="btn actionbtn" onClick={() => EditCategory(user)}>
                                            <Image src={EditIcon} alt="edit icon" />
                                        </button>
                                        <button className="btn actionbtn" onClick={() => DeleteCategory(user)}>
                                            <Image src={DeleteIcon} alt="delete icon" />
                                        </button>
                                    </td>
                                </tr>
                            </React.Fragment>)
                            })}
                            {categoryList && categoryList.length === 0 && <tr><td style={{ textAlign: "center" }} colSpan={4}>Category not found.</td></tr>}
                        </tbody>
                    </table>
                </div>
            </Scrollbars>
            {/* pagination */}
            {parseInt(paginationLength?.total_records) > 10 && (<CommonPagination 
                currentPage={currentPage}
                paginationLength={paginationLength}
                currentFunction={currentFunction}
            />)}
        </div>
        {showModal?.open && (<CommonModal showModal={showModal} setShowModal={setShowModal} />)}
    </>);
}

export default CategoryManagement;